import { Form, Formik } from 'formik';
import React from 'react';
import ModalComponent from '../../../components/modal/modal';
import { ModalStatusType } from '../../../types/common';
import ModalBodyComponent from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import FormSelect from '../../../components/dropdown/formSelect';
import { YesNoBoolean } from '../../../constants/common';
import InputText from '../../../components/input-text/inputText';
import CustomCheckBox from '../../../components/radio-button/customCheckBox';
import Heading from '../../../components/typography';
import CustomTextArea from '../../../components/text-area/textArea';
import InitialValuesForm from '../../../constants/initialValues';
import {
  useGetActiveTransferList,
  usePostTransferAgentSetting,
  useWealthlaneAwardApi,
} from '../../../hooks';
import { Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentIntegrationDto } from '@wealthlane/api-services/wealthlane-award-service';
import _ from 'lodash';

interface TransferAgentSettingModalType {
  isModalOpen: boolean;
  closeModal: () => void;
  setModalStatus: (value: ModalStatusType) => void;
  loading: boolean;
  modalStatus: ModalStatusType;
  transferAgentDetails?: Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentIntegrationDto;
}

const TransferAgentSettingModal = ({
  isModalOpen,
  closeModal,
  setModalStatus,
  loading,
  modalStatus,
  transferAgentDetails,
}: TransferAgentSettingModalType) => {
  const { handleRequest } = useWealthlaneAwardApi();
  const { data: activeTransferListOptions, isLoading: isActiveTransferListLoading } =
    useGetActiveTransferList(handleRequest);

  const { mutate: postTransferAgentSetting, isLoading: isPostTransferAgentSettingLoading } =
    usePostTransferAgentSetting(handleRequest, closeModal, transferAgentDetails?.id);

  return (
    <Formik
      enableReinitialize
      initialValues={
        transferAgentDetails ? transferAgentDetails : InitialValuesForm.transferAgentSetting
      }
      //   validationSchema={FEE_VALIDATION}
      onSubmit={(values) => {
        postTransferAgentSetting(values);
      }}>
      {({
        touched,
        handleChange,
        errors,
        values,
        setFieldValue,
        setFieldTouched,
        setValues,
        setTouched,
      }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            loading={loading}
            size='md'
            // valueEdited={_.isEqual(values, initialData.data)}
            title={`${modalStatus} Transfer Agent Setting`}
            // showToolTip={true}
            // tooltipText={`Permissions allow a company to control its users’ access levels to the module and its fields depending on their roles and functions. Users can have multiple levels of access such as creating and editing a module, to read-only or none at all.`}
            children={
              <Form>
                <ModalBodyComponent>
                  <div>
                    <FormSelect
                      type='text'
                      label='Transfer Agent'
                      name='transferAgentId'
                      viewName='transferAgentId'
                      onChange={handleChange}
                      errors={errors}
                      touched={touched}
                      options={activeTransferListOptions}
                      //   isLoading={isPerformanceRuleTypesLoading}
                      values={values}
                      setFieldValue={setFieldValue}
                      inputType={modalStatus}
                      disabled={modalStatus === 'View'}
                      required
                    />
                    <InputText
                      type='text'
                      label='Client Id'
                      name='clientId'
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                      errors={errors}
                      touched={touched}
                      inputType={modalStatus}
                      disabled={modalStatus === 'View'}
                      required
                    />
                    <InputText
                      type='text'
                      label='Client Secret'
                      name='clientSecret'
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                      errors={errors}
                      touched={touched}
                      inputType={modalStatus}
                      disabled={modalStatus === 'View'}
                      required
                    />
                    <CustomCheckBox
                      name='isEnabled'
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                      errors={errors}
                      touched={touched}
                      className={'individual-check mb-4'}
                      labelClassName={'whitespace-normal'}
                      disabled={modalStatus === 'View'}
                      checked={values?.isEnabled}
                      id='acceptCheck'
                      label={<Heading variant='body-xs' className='mt-1' title={'Is Enabled'} />}
                      required
                    />
                    <CustomTextArea
                      label='Description'
                      name='description'
                      onChange={handleChange}
                      errors={errors}
                      inputType={modalStatus}
                      disabled={modalStatus === 'View'}
                      touched={touched}
                      rows='3'
                      required
                    />
                  </div>
                </ModalBodyComponent>
                <ModalFooterComponent
                  modalStatus={modalStatus}
                  onCloseModal={() => {
                    closeModal();
                  }}
                  onEditModal={() => {
                    setModalStatus('Edit');
                  }}
                  valueChanged={_.isEqual(values, transferAgentDetails)}
                  loading={isPostTransferAgentSettingLoading}
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default TransferAgentSettingModal;
